<template>
  <div class="flex-1 text-ui-lg font-ui">
    <div class="flex flex-col gap-4.5">
      <slot />
    </div>
  </div>
</template>
